import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { Currency } from "_shared/money/currencies/currency";
import { z } from "zod";

export type MoneyJSON = z.infer<typeof MoneySchema.type>;
export type MoneyParams = z.infer<typeof MoneySchema.type>;

export default class MoneySchema {
  public static readonly type = z.object({
    amount: z.number(),
    currency: z.enum(Currency)
  });

  public static validate(values: unknown): MoneyParams {
    return parseOrThrow(
      MoneySchema.type,
      values,
      { 
        logError: true,
        schemaName: "MoneySchema",
        operation: "validate",
        payloadSample: values 
      }
    );
  }

  public static isValid(values: unknown): values is MoneyParams {
    try {
      MoneySchema.validate(values);
      return true;
    } catch {
      return false;
    }
  }
}
